import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addOn = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _bulkAddOnResult = { item: '_addOn' };
var _bulkCreateAddOnsRequest = { addOns: '_addOn' };
var _bulkCreateAddOnsResponse = { results: '_bulkAddOnResult' };
var _bulkDeleteAddOnsRequest = {};
var _bulkDeleteAddOnsResponse = {};
var _bulkUpdateAddOnsRequest = { addOns: '_maskedAddOn' };
var _bulkUpdateAddOnsResponse = {
    results: '_bulkUpdateAddOnsResponseBulkAddOnResult',
};
var _bulkUpdateAddOnsResponseBulkAddOnResult = { item: '_addOn' };
var _bulkUpdateAddOnTagsByFilterRequest = {};
var _bulkUpdateAddOnTagsByFilterResponse = {};
var _bulkUpdateAddOnTagsRequest = {};
var _bulkUpdateAddOnTagsResponse = {};
var _createAddOnRequest = { addOn: '_addOn' };
var _createAddOnResponse = { addOn: '_addOn' };
var _deleteAddOnRequest = {};
var _deleteAddOnResponse = {};
var _getAddOnRequest = {};
var _getAddOnResponse = { addOn: '_addOn' };
var _maskedAddOn = {
    fieldMask: 'google.protobuf.FieldMask',
    addOn: '_addOn',
};
var _queryAddOnsRequest = {};
var _queryAddOnsResponse = { addOns: '_addOn' };
var _updateAddOnRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    addOn: '_addOn',
};
var _updateAddOnResponse = { addOn: '_addOn' };
function resolveWixAddonsV1AddOnsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/add-ons-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/add-ons-service',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/add-ons-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates an AddOn. */
export function createAddOn(payload) {
    var _a = serializer(_createAddOnRequest, {
        _addOn: _addOn,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAddOnResponse, { _addOn: _addOn }).fromJSON;
    function __createAddOn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'POST',
            methodFqn: 'wix.addons.v1.AddOnsService.CreateAddOn',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/add-ons',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAddOn.fromReq = fromReq;
    __createAddOn.__isAmbassador = true;
    return __createAddOn;
}
/** Retrieves a AddOn. */
export function getAddOn(payload) {
    var _a = serializer(_getAddOnRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAddOnResponse, { _addOn: _addOn }).fromJSON;
    function __getAddOn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'GET',
            methodFqn: 'wix.addons.v1.AddOnsService.GetAddOn',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/add-ons/{addOnId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAddOn.fromReq = fromReq;
    __getAddOn.__isAmbassador = true;
    return __getAddOn;
}
/**
 * Updates an existing AddOn.
 *
 *
 * Each time the AddOn is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the AddOn.
 * This ensures you're working with the latest AddOn
 * and prevents unintended overwrites.
 */
export function updateAddOn(payload) {
    var _a = serializer(_updateAddOnRequest, {
        _addOn: _addOn,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAddOnResponse, { _addOn: _addOn }).fromJSON;
    function __updateAddOn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'PATCH',
            methodFqn: 'wix.addons.v1.AddOnsService.UpdateAddOn',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/add-ons/{addOn.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAddOn.fromReq = fromReq;
    __updateAddOn.__isAmbassador = true;
    return __updateAddOn;
}
/** Deletes an existing AddOn. */
export function deleteAddOn(payload) {
    var _a = serializer(_deleteAddOnRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAddOnResponse, {}).fromJSON;
    function __deleteAddOn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'DELETE',
            methodFqn: 'wix.addons.v1.AddOnsService.DeleteAddOn',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/add-ons/{addOnId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAddOn.fromReq = fromReq;
    __deleteAddOn.__isAmbassador = true;
    return __deleteAddOn;
}
/**
 * Retrieves a list of AddOns, given the provided [paging, filtering, and sorting][1].
 *
 * Up to 1,000 AddOns can be returned per request.
 *
 * To learn how to query AddOns, see [API Query Language][2].
 *
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function queryAddOns(payload) {
    var _a = serializer(_queryAddOnsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAddOnsResponse, { _addOn: _addOn }).fromJSON;
    function __queryAddOns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'GET',
            methodFqn: 'wix.addons.v1.AddOnsService.QueryAddOns',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/add-ons/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixAddonsV1AddOnsServiceUrl({
                        protoPath: '/v1/add-ons/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryAddOns.fromReq = fromReq;
    __queryAddOns.__isAmbassador = true;
    return __queryAddOns;
}
/** Creates multiple AddOns in a single request. Works synchronously. */
export function bulkCreateAddOns(payload) {
    var _a = serializer(_bulkCreateAddOnsRequest, { _addOn: _addOn }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateAddOnsResponse, {
        _addOn: _addOn,
        _bulkAddOnResult: _bulkAddOnResult,
    }).fromJSON;
    function __bulkCreateAddOns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'POST',
            methodFqn: 'wix.addons.v1.AddOnsService.BulkCreateAddOns',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/bulk/add-ons/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateAddOns.fromReq = fromReq;
    __bulkCreateAddOns.__isAmbassador = true;
    return __bulkCreateAddOns;
}
/** Updates multiple AddOns in a single request. Works synchronously. */
export function bulkUpdateAddOns(payload) {
    var _a = serializer(_bulkUpdateAddOnsRequest, { _addOn: _addOn, _maskedAddOn: _maskedAddOn }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateAddOnsResponse, {
        _addOn: _addOn,
        _bulkUpdateAddOnsResponseBulkAddOnResult: _bulkUpdateAddOnsResponseBulkAddOnResult,
    }).fromJSON;
    function __bulkUpdateAddOns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'POST',
            methodFqn: 'wix.addons.v1.AddOnsService.BulkUpdateAddOns',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/bulk/add-ons/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateAddOns.fromReq = fromReq;
    __bulkUpdateAddOns.__isAmbassador = true;
    return __bulkUpdateAddOns;
}
/** Deletes multiple AddOns in a single request. Works synchronously. */
export function bulkDeleteAddOns(payload) {
    var _a = serializer(_bulkDeleteAddOnsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteAddOnsResponse, {}).fromJSON;
    function __bulkDeleteAddOns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'POST',
            methodFqn: 'wix.addons.v1.AddOnsService.BulkDeleteAddOns',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/bulk/add-ons/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteAddOns.fromReq = fromReq;
    __bulkDeleteAddOns.__isAmbassador = true;
    return __bulkDeleteAddOns;
}
/**
 * Synchronously update tags on multiple AddOns, by list of AddOns ids
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateAddOnTags(payload) {
    var _a = serializer(_bulkUpdateAddOnTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateAddOnTagsResponse, {}).fromJSON;
    function __bulkUpdateAddOnTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'POST',
            methodFqn: 'wix.addons.v1.AddOnsService.BulkUpdateAddOnTags',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/bulk/add-ons/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateAddOnTags.fromReq = fromReq;
    __bulkUpdateAddOnTags.__isAmbassador = true;
    return __bulkUpdateAddOnTags;
}
/**
 * Asynchronously update tags on multiple AddOns, by provided filter
 * An empty filter will update all AddOns
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateAddOnTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateAddOnTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateAddOnTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateAddOnTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.addons.v1.add_on',
            method: 'POST',
            methodFqn: 'wix.addons.v1.AddOnsService.BulkUpdateAddOnTagsByFilter',
            url: resolveWixAddonsV1AddOnsServiceUrl({
                protoPath: '/v1/bulk/add-ons/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateAddOnTagsByFilter.fromReq = fromReq;
    __bulkUpdateAddOnTagsByFilter.__isAmbassador = true;
    return __bulkUpdateAddOnTagsByFilter;
}
//# sourceMappingURL=http.impl.js.map